module.exports = __webpack_public_path__ + "fonts/iconfont.36a0bf59.woff2";